// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"9503ecf9","70":"b3b6baec","84":"3c8f2997","126":"aa0714a4","236":"9384d3f5","240":"dfa933c7","451":"2097a634","479":"84985948","489":"d94728b8","522":"633b425e","601":"24256e3c","645":"4169d6ee","653":"4e2165bf","706":"65eda6b0","756":"194dc70b","771":"ed67a5ff"}[chunkId] + ".chunk.js";
};